import { t } from "i18next";
import * as z from "zod";

/**
 * Schémas des contestations de transfert (TransactionDisputes, guide v3.1).
 * Factory (règle projet) : créés via `create*Schema()` et mémoïsés au
 * niveau composant sur la langue courante — jamais d'instance exportée.
 */

/** Ouverture (`POST /TransactionDisputes/open`) : motif 5 à 500 caractères. */
export const createOpenTransactionDisputeSchema = () =>
  z.object({
    reason: z
      .string()
      .trim()
      .min(5, { message: t("wallet.disputes.form.reasonTooShort") })
      .max(500, { message: t("wallet.disputes.form.reasonTooLong") }),
  });
export type OpenTransactionDisputeFormValues = z.infer<
  ReturnType<typeof createOpenTransactionDisputeSchema>
>;

/** Rejet (`POST /TransactionDisputes/{id}/reject`) : note 5 à 500 caractères. */
export const createRejectTransactionDisputeSchema = () =>
  z.object({
    note: z
      .string()
      .trim()
      .min(5, { message: t("wallet.disputes.form.reasonTooShort") })
      .max(500, { message: t("wallet.disputes.form.reasonTooLong") }),
  });
export type RejectTransactionDisputeFormValues = z.infer<
  ReturnType<typeof createRejectTransactionDisputeSchema>
>;
